/* Dragon easter eggs.
   Egg 1 (live): catch a floating dragon and it blasts off screen with a fire trail,
   then fades back in at its spot a few seconds later.
   More eggs (e.g. Plato) plug into EGGS below later.
   Also: the dragon head in the nav breathes fire at random (every 20-40s) and on hover/tap. */
(function(){
  var h = document.documentElement;

  function rand(a, b){ return a + Math.random() * (b - a); }
  function reduced(){ return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function catchable(){ return !h.classList.contains('dragons-down') && !h.classList.contains('boring-mode'); }
  function isGrey(){ return h.classList.contains('grey-mode') || h.classList.contains('boring-mode'); }

  var FIRE = '\uD83D\uDD25';

  function flame(x, y, size){
    var s = document.createElement('span');
    s.className = 'dragon-flame';
    s.textContent = FIRE;
    s.style.left = x + 'px';
    s.style.top = y + 'px';
    s.style.fontSize = (size || Math.round(rand(18, 34))) + 'px';
    document.body.appendChild(s);
    setTimeout(function(){ if (s.parentNode) s.parentNode.removeChild(s); }, 750);
  }

  function fireEgg(d){
    var r = d.getBoundingClientRect();
    var cx = r.left + r.width / 2;
    var cy = r.top + r.height / 2;
    var dir = cx < window.innerWidth / 2 ? -1 : 1;
    var noMotion = reduced();

    // Freeze the dragon where it was caught
    d.style.animation = 'none';
    d.style.transition = 'none';
    d.style.left = r.left + 'px';
    d.style.top = r.top + 'px';
    d.style.bottom = 'auto';
    d.style.transform = 'none';
    d.style.zIndex = '7';
    void d.offsetWidth;

    // Ignition burst
    for (var i = 0; i < 6; i++) {
      flame(cx + rand(-r.width * 0.4, r.width * 0.4), cy + rand(-r.height * 0.3, r.height * 0.3), Math.round(rand(22, 40)));
    }

    // Wind-up shake
    if (d.animate && !noMotion) {
      d.animate([
        { transform: 'translateX(0) rotate(0deg)' },
        { transform: 'translateX(-6px) rotate(-8deg)' },
        { transform: 'translateX(6px) rotate(8deg)' },
        { transform: 'translateX(-4px) rotate(-5deg)' },
        { transform: 'translateX(0) rotate(0deg)' }
      ], { duration: 350 });
    }

    setTimeout(function(){
      var tx = dir * (window.innerWidth + r.width + 200);
      var ty = rand(-0.35, 0.05) * window.innerHeight;
      d.style.transition = noMotion ? 'none' : 'transform 0.9s cubic-bezier(0.5,0,0.9,0.4)';
      d.style.transform = 'translate(' + tx + 'px,' + ty + 'px) rotate(' + (dir * -12) + 'deg)';

      if (!noMotion) {
        var start = Date.now();
        var iv = setInterval(function(){
          var rr = d.getBoundingClientRect();
          flame(rr.left + rr.width * (dir > 0 ? 0.15 : 0.85), rr.top + rr.height * 0.6);
          if (Date.now() - start > 900) clearInterval(iv);
        }, 45);
      }

      // Come back home a few seconds later
      setTimeout(function(){
        d.style.transition = 'none';
        d.style.opacity = '0';
        ['animation', 'left', 'top', 'bottom', 'transform', 'zIndex'].forEach(function(p){ d.style[p] = ''; });
        void d.offsetWidth;
        d.style.transition = 'opacity 0.8s ease';
        d.style.opacity = '1';
        setTimeout(function(){
          d.style.transition = '';
          d.style.opacity = '';
          delete d.dataset.busy;
        }, 850);
      }, 3500);
    }, noMotion ? 0 : 380);
  }

  var EGGS = [fireEgg];

  function onCatch(e){
    var d = e.currentTarget;
    if (d.dataset.busy === '1' || !catchable()) return;
    d.dataset.busy = '1';
    var egg = EGGS[Math.floor(Math.random() * EGGS.length)];
    egg(d);
  }

  Array.prototype.forEach.call(document.querySelectorAll('.floating-dragon'), function(d){
    d.addEventListener('click', onCatch);
  });

  /* ---------- Nav dragon head breathes fire ---------- */
  var head = document.querySelector('.nav-home-icon img');
  var breathing = false;

  function breathe(){
    if (!head || breathing || isGrey() || reduced()) return;
    var r = head.getBoundingClientRect();
    if (r.width === 0) return;
    breathing = true;

    // Head puffs up, then fires
    if (head.animate) {
      head.animate([
        { transform: 'scale(1) rotate(0deg)' },
        { transform: 'scale(1.18) rotate(4deg)', offset: 0.3 },
        { transform: 'scale(1.32) rotate(-6deg)', offset: 0.55 },
        { transform: 'scale(1.25) rotate(-4deg)', offset: 0.85 },
        { transform: 'scale(1) rotate(0deg)' }
      ], { duration: 1300, easing: 'ease-out' });
    }

    // Mouth sits at the left of the head, a bit below middle
    setTimeout(function(){
      var rr = head.getBoundingClientRect();
      var mx = rr.left + rr.width * 0.08;
      var my = rr.top + rr.height * 0.62;
      var count = Math.round(rand(9, 14));
      for (var i = 0; i < count; i++) {
        (function(i){
          setTimeout(function(){
            var s = document.createElement('span');
            s.className = 'nav-flame';
            s.textContent = FIRE;
            s.style.left = mx + 'px';
            s.style.top = my + 'px';
            s.style.fontSize = Math.round(rand(12, 22)) + 'px';
            document.body.appendChild(s);
            var dx = -rand(45, 120);
            var dy = rand(-12, 26);
            var anim = s.animate([
              { transform: 'translate(-50%, -50%) scale(0.4)', opacity: 1 },
              { transform: 'translate(calc(-50% + ' + (dx * 0.55) + 'px), calc(-50% + ' + (dy * 0.4) + 'px)) scale(1.15)', opacity: 1, offset: 0.5 },
              { transform: 'translate(calc(-50% + ' + dx + 'px), calc(-50% + ' + (dy - 10) + 'px)) scale(0.5)', opacity: 0 }
            ], { duration: Math.round(rand(550, 800)), easing: 'ease-out' });
            anim.onfinish = function(){ if (s.parentNode) s.parentNode.removeChild(s); };
          }, i * 45);
        })(i);
      }
    }, 380);

    setTimeout(function(){ breathing = false; }, 1500);
  }

  function scheduleBreath(){
    setTimeout(function(){
      if (!document.hidden) breathe();
      scheduleBreath();
    }, Math.round(rand(20000, 40000)));
  }

  if (head && head.animate) {
    head.addEventListener('mouseenter', breathe);
    head.addEventListener('touchstart', breathe, { passive: true });
    scheduleBreath();
  }
})();
